import React, {useState, useEffect} from 'react';
import {getManifestations} from './queries';
import {Spinner} from '../Spinner/Spinner';
import {runQuery} from '../utils'


export interface MyComponentProps {
  // Define your prop types here
  eresourceid: string,
  tresourceid?: string,
  secondaryTresourceid?: string,
  handleChangeInfo: any
  handleChangeSecondaryInfo: any
  
}

export const ManifestationsList: React.FC<MyComponentProps> = ({eresourceid, handleChangeInfo, tresourceid, secondaryTresourceid, handleChangeSecondaryInfo}) => {
  const [manifestations, setManifestations] = useState<any[]>([]);

  let tokenRange: any;
  if (eresourceid?.split("@")[1]){
    tokenRange = {start: parseInt(eresourceid.split("@")[1].split("-")[0]), end: parseInt(eresourceid.split("@")[1].split("-")[1])}
  }
  eresourceid = eresourceid?.split("@")[0]

  useEffect(() => {
    const fetchData = async () => {
      const data = await runQuery(getManifestations(eresourceid));
      const results = data.data.results.bindings.map((i:any) => ({id: i.manifestation.value, title: i.manifestationTitle.value}))
      setManifestations(results);
    }
    fetchData();
  }, [eresourceid]);

  const displayManifestations = () => {
    if (manifestations.length > 0){
      return manifestations.map((m: any) => {
        if (tresourceid?.includes(m.id)){
          return (<p key={m.id} onClick={() => handleChangeInfo(m.id)}>{m.title} (Current Focus)</p>)
        }
        if (secondaryTresourceid?.includes(m.id)){
          return (
          <p key={m.id}>{m.title} (Current Secondary) <span className="lbp-span-link" onClick={() => handleChangeSecondaryInfo()}>RS</span>
            <span className="lbp-span-link" onClick={() => handleChangeInfo(m.id)} title="make primary focus">CP</span>
          </p>)
        }
        else{
          return (
          <p key={m.id}>{m.title}
            <span className="lbp-span-link" onClick={() => handleChangeInfo(m.id)} title="make primary focus">CP</span> 
            | 
            <span className="lbp-span-link" onClick={() => handleChangeSecondaryInfo(m.id)} title="make secondary focus">CS</span>
          </p>)
        }
      })
    }
  }
  return(
    <div>
      <br/>
      <h4>Available Manifestations</h4>
      {displayManifestations()}
    </div>
      
  )
}